import { cn } from '@core/design-system/tailwind/lib/utils';
import { ArrowUp, ArrowDown } from 'lucide-react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  profitability: string;
  isPositive: boolean;
}

export const Profit = ({ profitability, isPositive, ...props }: Props) => {
  return (
    <div
      title="Rentabilidade dos últimos 12 meses"
      {...props}
      className={cn(props.className, 'leading-4 space-y-0.5')}
    >
      <div className="flex space-x-1 items-center">
        <div
          className={cn(
            'w-4 h-4 rounded flex justify-center items-center',
            isPositive ? 'bg-positive' : 'bg-negative'
          )}
        >
          {isPositive ? (
            <ArrowUp size={13} className="text-white" />
          ) : (
            <ArrowDown size={13} className="text-white" />
          )}
        </div>

        <span
          className={cn(
            'text-xs font-semibold',
            isPositive ? 'text-positive' : 'text-negative'
          )}
        >
          {profitability}
        </span>
      </div>

      <span className="text-2xs font-light hidden sm:block">
        Rentabilidade 12M
      </span>
    </div>
  );
};
